import * as Yup from 'yup';
import { StepNewOperatorForm } from './step-new-operator-types';

export const stepNewOperatorSchema = () =>
  Yup.object<StepNewOperatorForm>().shape({
    identifierType: Yup.string().nullable().required('Povinné pole'),
    newOperatorIdentifier: Yup.string().nullable().required('Povinné pole'),
  });
